import styled from '@emotion/styled'

import { breakpoints, palette, spacing } from '../../ui'
import rose2GradientEnd from './GradientColor'

export const Container = styled.div`
  align-items: center;
  background: linear-gradient(233.65deg, ${palette.rose2} 1.89%, ${rose2GradientEnd} 100%);
  display: flex;
  flex-direction: column;
  padding-bottom: ${spacing.majorScale(23)}px;
  padding-left: ${spacing.majorScale(3)}px;
  padding-right: ${spacing.majorScale(3)}px;
  padding-top: ${spacing.majorScale(19)}px;
  text-align: center;
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  margin-left: -${spacing.minorScale(1)}px; /* so buttons fit on one line for iPhone X */
  margin-top: ${spacing.majorScale(3)}px;
`

export const ButtonContainer = styled.div`
  margin: ${spacing.minorScale(1) / 2}px;

  @media (min-width: ${breakpoints.lg}px) {
    margin: ${spacing.majorScale(2) / 2}px;
  }
`
